<template>
  <div>
    <notifications-container />
    <loader />
    <router-view v-if="!isLoadingDictionary" />
    <profile-update-required-popup />
  </div>
</template>

<script>
import NotificationsContainer from '@/components/notifications/notifications-container'
import Loader from '@/components/loader'
import ProfileUpdateRequiredPopup from '@/components/popup/profile-update-required-popup'

import i18n from '@/helpers/i18n'
import LoaderService from '@/services/loader'
import ConfigService from '@/services/config'

export default {
  data() {
    return {
      isLoadingDictionary: true
    }
  },
  components: {
    NotificationsContainer,
    Loader,
    ProfileUpdateRequiredPopup
  },
  async mounted() {
    LoaderService.showLoader()
    await i18n.loadDictionary()
    await ConfigService.loadConfig()
    LoaderService.hideLoader()
    this.isLoadingDictionary = false
  }
}
</script>
